import axios from "axios";
import { useState } from "react";
import { useGlobalContext } from "../context";

const url = process.env.REACT_APP_API_URL + "/cart";

function CartItem({
  _id,
  description,
  image,
  title,
  price,
}) {
  const { fetchCartItems } = useGlobalContext();
  const [quantity, setQuantity] = useState(1);

  /**
   * @desc Keep track of item quantity
   * @param {*}
   */
  const handleChange = async (e) => {
    setQuantity(e.target.value);
    const itemObj = {
      itemId: _id,
      cartId: JSON.parse(localStorage.getItem("ekartToken")).cartId,
      quantity: e.target.value,
      price: price,
      total: e.target.value * price
    }

    await axios.patch(`${url}/quantity/${_id}`, itemObj, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
      },
    });
  };

  /**
   * @desc Remove an item from cart
   */
  const removeItem = async () => {
    await axios.delete(`${url}/${_id}`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
      },
      data: {
        cartId: JSON.parse(localStorage.getItem("ekartToken")).cartId,
      },
    });

    fetchCartItems();
  };

  return (
    <div className="container card">
      <div className="row card-body">
        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 d-flex justify-content-center align-items-center">
          <img
            style={{ maxWidth: "10rem", margin: "0 auto" }}
            alt={title}
            src={image}
          />
        </div>
        <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12 d-flex flex-column justify-content-center align-items-center">
          <p className="fw-bold fs-4">{title}</p>
          <p style={{ width: "10rem" }}>{description}</p>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 d-flex justify-content-center flex-column align-items-center">
          <select className="form-select" value={quantity} onChange={handleChange}>
            <option>Quantity</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
          <p className="fw-bold fs-4">₹ {price * quantity}</p>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center">
          <button className="btn btn-danger" onClick={removeItem}>
            Remove
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartItem;
